// Rich, keyword-focused SEO content per service — makes each landing page "fett".
export const SERVICE_SEO = {
  "chiptuning-cloppenburg": {
    heading: "Chiptuning vom Profi im Raum Cloppenburg",
    paragraphs: [
      "Du suchst professionelles Chiptuning in Cloppenburg und Umgebung? Bei KeyMaster KFZ holen wir mit einer individuellen Kennfeldoptimierung das Maximum aus deinem Motor – ob Diesel oder Benziner, Turbo oder Sauger. Statt pauschaler Standard-Files erstellen wir eine Abstimmung, die exakt zu deinem Fahrzeug, deiner Fahrweise und deinen Zielen passt. So bekommst du spürbar mehr Drehmoment, einen kräftigeren Durchzug im mittleren Drehzahlbereich und ein direkteres Ansprechverhalten.",
      "Als mobiler Spezialist sind wir im gesamten Landkreis Cloppenburg für dich da – von Löningen über Friesoythe bis Emstek und Garrel. Wir beraten dich ehrlich zu realistischer Mehrleistung, Eintragung, Versicherung und Langlebigkeit. Kein leeres Marketing, sondern saubere Arbeit mit erprobter Technik. Frag jetzt dein persönliches Chiptuning-Angebot für Cloppenburg an.",
    ],
    checklist: [
      "Leistungssteigerung für Diesel & Benziner (TDI, TSI, HDI u. a.)",
      "Kennfeldoptimierung für mehr Drehmoment & Durchzug",
      "OBD- oder Bootmode-Tuning – je nach Fahrzeug",
      "Ehrliche Beratung zu Eintragung & Versicherung",
      "Serienstand jederzeit wiederherstellbar",
    ],
  },
  "softwareoptimierung-cloppenburg": {
    heading: "ECU-Softwareoptimierung in Cloppenburg",
    paragraphs: [
      "Die Motorsteuerung (ECU) ist das Gehirn deines Fahrzeugs. Mit unserer Softwareoptimierung im Raum Cloppenburg passen wir Kennfelder wie Ladedruck, Einspritzung und Gaspedalkennlinie präzise an – für mehr Laufkultur, ein feineres Ansprechverhalten und ein harmonischeres Fahrgefühl. Ob sparsam, sportlich oder ausgewogen: Du bestimmst das Ziel, wir liefern die passende Abstimmung.",
      "Wir arbeiten marken- und modellübergreifend und sichern immer zuerst deine Original-Software. So bleibt dein Fahrzeug jederzeit rückrüstbar. Vereinbare jetzt deinen Termin für eine professionelle ECU-Optimierung in Cloppenburg und dem Oldenburger Münsterland.",
    ],
    checklist: [
      "Optimierung der Gaspedalkennlinie & Lastwechsel",
      "Harmonisierung von Ladedruck, Zündung & Einspritzung",
      "Effizienz-, Komfort- oder Leistungs-Setup nach Wunsch",
      "Datensicherung & Rückrüstbarkeit inklusive",
      "Marken- & modellübergreifend",
    ],
  },
  "steuergeraet-reparatur": {
    heading: "Steuergerät-Reparatur statt teurem Austausch",
    paragraphs: [
      "Ein defektes Motor- oder Getriebesteuergerät bedeutet nicht automatisch hohe Austauschkosten. In vielen Fällen lässt sich das Steuergerät auf Bauteilebene reparieren – im Raum Cloppenburg fachgerecht und deutlich günstiger als ein Neuteil. Da das Originalgerät erhalten bleibt, entfällt zudem meist die aufwändige Neucodierung an dein Fahrzeug.",
      "Wir führen eine fundierte Diagnose durch, grenzen den Defekt präzise ein und setzen dein Steuergerät zuverlässig wieder instand. Schnelle Durchlaufzeiten sorgen dafür, dass dein Auto zügig wieder einsatzbereit ist. Sende uns die Details zu deinem Steuergerät und erhalte eine ehrliche Einschätzung.",
    ],
    checklist: [
      "Reparatur von Motor- & Getriebesteuergeräten",
      "Diagnose & Fehlereingrenzung auf Bauteilebene",
      "Keine Neucodierung nötig – Originalgerät bleibt erhalten",
      "Deutlich günstiger als der Austausch",
      "Kurze Durchlaufzeiten & faire Gewährleistung",
    ],
  },
  "wegfahrsperre-deaktivieren": {
    heading: "Wegfahrsperre & Immobilizer im Raum Cloppenburg",
    paragraphs: [
      "Springt dein Auto wegen der Wegfahrsperre nicht mehr an? Ob defekter Transponder, Elektronikfehler oder verlorener Schlüssel – wir diagnostizieren das Problem am Immobilizer und bringen dein Fahrzeug im Raum Cloppenburg wieder sicher zum Laufen. Viele Arbeiten führen wir mobil direkt bei dir vor Ort durch.",
      "Wir lernen vorhandene oder neue Schlüssel fachgerecht an und beheben Fehler an der Wegfahrsperre markenübergreifend. Für Arbeiten am Immobilizer benötigen wir einen Eigentumsnachweis – so ist alles rechtssicher. Melde dich für eine schnelle Lösung.",
    ],
    checklist: [
      "Immobilizer-Fehler diagnostizieren & beheben",
      "Schlüssel an die Wegfahrsperre anlernen",
      "Hilfe auch bei komplettem Schlüsselverlust",
      "Mobil direkt vor Ort im Raum Cloppenburg",
      "Rechtssicher mit Eigentumsnachweis",
    ],
  },
  "schluesseldienst-cloppenburg": {
    heading: "Mobiler KFZ-Schlüsseldienst Cloppenburg",
    paragraphs: [
      "KeyMaster ist dein mobiler KFZ-Schlüsseldienst im Raum Cloppenburg. Wir kommen direkt zu dir – nach Hause, zur Arbeit oder an den Pannenort – und kümmern uns um alles rund um den Autoschlüssel: nachmachen, anlernen, Notöffnung und Wegfahrsperre. So sparst du dir teures Abschleppen zur Vertragswerkstatt.",
      "Vom Kleinwagen bis zur Oberklasse arbeiten wir marken- und modellübergreifend, mit fairen und transparenten Preisen ohne versteckte Kosten. Unser Notdienst ist 24/7 erreichbar – auch abends, am Wochenende und an Feiertagen. Ruf an oder schreib uns per WhatsApp.",
    ],
    checklist: [
      "Autoschlüssel nachmachen & anlernen vor Ort",
      "Notöffnung ohne Beschädigung",
      "Hilfe bei Wegfahrsperre & Schlüsselverlust",
      "Markenunabhängig – vom Kleinwagen bis Oberklasse",
      "24/7 mobil im gesamten Raum Cloppenburg",
    ],
  },
  "auto-notoeffnung": {
    heading: "Auto-Notöffnung – 24/7 in Cloppenburg",
    paragraphs: [
      "Ausgesperrt oder Schlüssel im verschlossenen Auto? Unsere Auto-Notöffnung im Raum Cloppenburg hilft dir rund um die Uhr – schnell, professionell und in aller Regel ohne jede Beschädigung. Besonders wichtig: Bei eingeschlossenem Kind oder Haustier handeln wir sofort (bei akuter Gefahr bitte zusätzlich immer die 112 rufen).",
      "Mit spezieller Öffnungstechnik gelangen wir schonend in dein Fahrzeug, ohne Schloss oder Karosserie zu beschädigen. Dank kurzer Reaktionszeiten im gesamten Landkreis Cloppenburg bist du schnell wieder mobil. Speichere dir unsere Notrufnummer – im Ernstfall zählt jede Minute.",
    ],
    checklist: [
      "Türöffnung ohne Beschädigung",
      "24/7 Notdienst – auch nachts & feiertags",
      "Schnelle Anfahrt im gesamten Raum Cloppenburg",
      "Soforthilfe bei eingeschlossenem Kind oder Tier",
      "Faire Notdienst-Preise ohne böse Überraschungen",
    ],
  },
  "kfz-codierungen": {
    heading: "KFZ-Codierungen & Freischaltungen in Cloppenburg",
    paragraphs: [
      "Viele Fahrzeuge bringen ab Werk Funktionen mit, die einfach nicht aktiviert sind. Mit unseren KFZ-Codierungen im Raum Cloppenburg schalten wir versteckte Komfortfunktionen frei, binden Nachrüstungen sauber ein und passen dein Auto an deine Wünsche an – von Beleuchtung über Anzeigen bis hin zu Komfort-Features.",
      "Wir prüfen zuerst die Machbarkeit für dein Modell und codieren dann fachgerecht mit passender Technik, damit die Fahrzeugelektronik stabil bleibt. Die meisten Codierungen sind reversibel. Sag uns, welche Funktion du dir wünschst – wir sagen dir, was möglich ist.",
    ],
    checklist: [
      "Versteckte Komfortfunktionen freischalten",
      "Nachrüstungen sauber einbinden & anlernen",
      "Individuelle Anpassungen nach deinem Wunsch",
      "Machbarkeitsprüfung für dein Modell",
      "In der Regel reversibel",
    ],
  },
  "kfz-schluessel-nachmachen": {
    heading: "Autoschlüssel nachmachen in Cloppenburg",
    paragraphs: [
      "Ersatzschlüssel gefällig oder Schlüssel verloren? Wir machen deinen KFZ-Schlüssel im Raum Cloppenburg nach – vom einfachen Transponder über den Funk-Klappschlüssel bis zum modernen Keyless-Go-Smart-Schlüssel. Alles wird mobil und direkt am Fahrzeug angelernt, sodass dein neuer Schlüssel sofort funktioniert.",
      "Selbst wenn kein Originalschlüssel mehr vorhanden ist, können wir in vielen Fällen einen neuen Schlüssel anlernen. Das ist oft deutlich günstiger als der Weg über die Vertragswerkstatt. Nenne uns Marke, Modell und Baujahr für ein passendes Angebot.",
    ],
    checklist: [
      "Transponder-, Funk- & Keyless-Go-Schlüssel",
      "Programmierung direkt am Fahrzeug",
      "Neuer Schlüssel auch bei Totalverlust möglich",
      "Oft günstiger als die Vertragswerkstatt",
      "Mobil im gesamten Raum Cloppenburg",
    ],
  },
};
